import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE = "http://dietdubacherla.in/diet_backend";

const initialForm = {
  deecet_id: "",
  admission_no: "",
  batch: "",
  medium: "",
  optional_subject: "",
  surname: "",
  name: "",
  dob: "",
  aadhar: "",
  mobile: "",
  caste: "",
  father: "",
  father_mobile: "",
  mother: "",
  mother_mobile: "",
  village: "",
  mandal: "",
  district: "",
};

export default function StudentProfile() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  const [form, setForm] = useState({ ...initialForm, deecet_id: user?.college_id || "", name: user?.name || "" });
  const [photo, setPhoto] = useState(null);
  const [photoUrl, setPhotoUrl] = useState("");
  const [status, setStatus] = useState("");

  useEffect(() => {
    if (!user?.college_id) {
      navigate("/student-login");
      return;
    }

    axios
      .post(`${API_BASE}/student_profile.php`, {
        action: "get",
        deecet_id: user.college_id,
      })
      .then((res) => {
        if (res.data?.status === "success" && res.data.profile) {
          const profile = res.data.profile;
          setForm({
            ...initialForm,
            ...profile,
            deecet_id: profile.deecet_id || user.college_id,
            name: profile.name || user.name || "",
          });
          setPhotoUrl(profile.photo_url || "");
        }
      });
  }, []);

  const updateField = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const saveProfile = (e) => {
    e.preventDefault();
    setStatus("");

    const payload = new FormData();
    payload.append("action", "save");
    Object.entries(form).forEach(([key, value]) => payload.append(key, value || ""));
    if (photo) payload.append("photo", photo);

    axios
      .post(`${API_BASE}/student_profile.php`, payload, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        if (res.data?.status === "success") {
          setStatus("Profile saved successfully.");
          if (res.data.photo_url) setPhotoUrl(res.data.photo_url);
        } else {
          setStatus(res.data?.message || "Unable to save profile.");
        }
      })
      .catch(() => setStatus("Server error while saving profile."));
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <div>
          <h2 style={styles.title}>Student Profile</h2>
          <p style={styles.subtext}>Complete these details for admin verification.</p>
        </div>
        <button style={styles.secondaryButton} onClick={() => navigate("/student-dashboard")}>Dashboard</button>
      </div>

      <form style={styles.card} onSubmit={saveProfile}>
        <div style={styles.photoBlock}>
          {photoUrl ? <img src={photoUrl} alt="Student" style={styles.photo} /> : <div style={styles.photoEmpty}>Photo</div>}
          <input type="file" accept="image/png,image/jpeg,image/jpg,image/webp" onChange={(e) => setPhoto(e.target.files[0])} style={styles.input} />
        </div>

        <div style={styles.grid}>
          <Field label="DEECET ID" value={form.deecet_id} readOnly />
          <Field label="Admission No." value={form.admission_no} onChange={(value) => updateField("admission_no", value)} />
          <Field label="Batch" value={form.batch} placeholder="Ex: 2025-27, 2026-28" onChange={(value) => updateField("batch", value)} />
          <SelectField label="Medium" value={form.medium} onChange={(value) => updateField("medium", value)} options={["Tel", "Eng", "Hin"]} />
          <SelectField label="Optional Subject" value={form.optional_subject} onChange={(value) => updateField("optional_subject", value)} options={["Math", "Sci", "Social"]} />
          <Field label="Surname" value={form.surname} onChange={(value) => updateField("surname", value)} />
          <Field label="Name" value={form.name} onChange={(value) => updateField("name", value)} />
          <Field label="DOB" type="date" value={form.dob || ""} onChange={(value) => updateField("dob", value)} />
          <Field label="Aadhar" value={form.aadhar} onChange={(value) => updateField("aadhar", value)} />
          <Field label="Mobile" value={form.mobile} onChange={(value) => updateField("mobile", value)} />
          <Field label="Caste" value={form.caste} onChange={(value) => updateField("caste", value)} />
          <Field label="Father" value={form.father} onChange={(value) => updateField("father", value)} />
          <Field label="Father Mobile" value={form.father_mobile} onChange={(value) => updateField("father_mobile", value)} />
          <Field label="Mother" value={form.mother} onChange={(value) => updateField("mother", value)} />
          <Field label="Mother Mobile" value={form.mother_mobile} onChange={(value) => updateField("mother_mobile", value)} />
          <Field label="Village" value={form.village} onChange={(value) => updateField("village", value)} />
          <Field label="Mandal" value={form.mandal} onChange={(value) => updateField("mandal", value)} />
          <Field label="New District" value={form.district} onChange={(value) => updateField("district", value)} />
        </div>

        {status && <p style={styles.status}>{status}</p>}
        <button type="submit" style={styles.primaryButton}>Save Profile</button>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", placeholder = "", readOnly = false }) {
  return (
    <label style={styles.label}>
      <span>{label}</span>
      <input type={type} value={value || ""} readOnly={readOnly} placeholder={placeholder || label} onChange={(e) => onChange?.(e.target.value)} style={{ ...styles.input, ...(readOnly ? styles.readOnly : {}) }} />
    </label>
  );
}

function SelectField({ label, value, onChange, options }) {
  return (
    <label style={styles.label}>
      <span>{label}</span>
      <select value={value || ""} onChange={(e) => onChange(e.target.value)} style={styles.input}>
        <option value="">Select {label}</option>
        {options.map((option) => <option key={option} value={option}>{option}</option>)}
      </select>
    </label>
  );
}

const styles = {
  page: { minHeight: "100vh", background: "#eef2f6", padding: "20px", fontFamily: "Arial, sans-serif", color: "#1f2937" },
  header: { display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "center", marginBottom: "14px" },
  title: { margin: 0 },
  subtext: { margin: "4px 0 0", color: "#6b7280" },
  card: { background: "#fff", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "16px" },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "12px" },
  label: { display: "grid", gap: "6px", fontWeight: 600, fontSize: "13px" },
  input: { width: "100%", boxSizing: "border-box", padding: "10px", border: "1px solid #d1d5db", borderRadius: "6px", fontSize: "14px" },
  readOnly: { background: "#f3f4f6", color: "#6b7280" },
  photoBlock: { display: "grid", gridTemplateColumns: "90px minmax(180px, 1fr)", gap: "12px", alignItems: "center", marginBottom: "16px" },
  photo: { width: "90px", height: "90px", objectFit: "cover", borderRadius: "8px", border: "1px solid #e5e7eb" },
  photoEmpty: { width: "90px", height: "90px", borderRadius: "8px", border: "1px dashed #9ca3af", display: "grid", placeItems: "center", color: "#6b7280" },
  primaryButton: { marginTop: "14px", width: "100%", background: "#991b1b", color: "#fff", padding: "12px", border: "none", borderRadius: "6px", cursor: "pointer" },
  secondaryButton: { background: "#fff", color: "#991b1b", border: "1px solid #991b1b", padding: "9px 12px", borderRadius: "6px", cursor: "pointer" },
  status: { color: "#991b1b", fontWeight: 700 },
};
